/**
 * Login direto contra o NextAuth em /api/auth/callback/credentials (proxy do Vite → :3003 em dev,
 * nginx em produção). `admin=1` pede ao servidor o segundo fator; a sessão só vale no painel com ele.
 */
export async function entrarComoAdmin(email: string, senha: string, codigo?: string): Promise<string | null> {
  const csrfRes = await fetch("/api/auth/csrf", { credentials: "include" });
  const { csrfToken } = await csrfRes.json();
  const body = new URLSearchParams({ csrfToken, email, password: senha, admin: "1", callbackUrl: window.location.origin, json: "true" });
  if (codigo) body.set("codigo", codigo);

  const res = await fetch("/api/auth/callback/credentials", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body,
    credentials: "include",
    redirect: "manual",
  });
  // Com json:true o NextAuth devolve {url}; a falha vem como ?error=<motivo> nessa url.
  let dados: { url?: string; error?: string } = {};
  try {
    dados = JSON.parse(await res.text());
  } catch {
    // Resposta de redirect sem corpo: seguiu.
  }
  if (dados.error) return dados.error;
  if (dados.url) return new URL(dados.url, window.location.origin).searchParams.get("error");
  return null;
}

export async function sairDoAdmin() {
  const csrfRes = await fetch("/api/auth/csrf", { credentials: "include" });
  const { csrfToken } = await csrfRes.json();
  // redirect "manual": o 302 do signout aponta pra origem do web; seguir pelo fetch vira CORS e lança,
  // e quem chamou nunca chegava a navegar. O cookie já foi limpo na própria resposta do 302.
  await fetch("/api/auth/signout", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams({ csrfToken, callbackUrl: window.location.origin }),
    credentials: "include",
    redirect: "manual",
  });
}

export function mensagemDoErro(erro: string): string {
  if (erro.includes("MFA_INVALIDO")) return "Código incorreto ou já usado. Use o código atual do aplicativo ou um código de recuperação.";
  if (erro.includes("RATE_LIMIT")) return "Muitas tentativas. Aguarde alguns minutos e tente novamente.";
  if (erro.includes("CONTA_BLOQUEADA")) return "Esta conta está bloqueada.";
  if (erro.includes("EMAIL_NAO_CONFIRMADO")) return "Confirme o e-mail da conta antes de entrar. Enviamos um link novo.";
  return "E-mail ou senha incorretos.";
}
